<script lang="ts">
import { defineComponent } from "vue";
import poolFilters from "../../assets/conf/pool_filters.json";
import { groupBy } from "lodash";
import KlereoCheckbox from "@/shared/components/KlereoCheckbox.vue";
import KlereoIcon from "@/shared/components/KlereoIcon.vue";

export default defineComponent({
  components: { KlereoIcon, KlereoCheckbox },
  emits: ["change"],
  data: function () {
    return {
      filterState: Object.fromEntries(
        poolFilters.map((filter) => [filter.key, true])
      ),
      categories: groupBy(poolFilters, (filter) => filter.category),
      openCategory: null as string | null,
    };
  },
  watch: {
    filterState() {
      this.$emit("change", this.filterState);
    },
  },
  methods: {
    onStateChange() {
      this.$emit(
        "change",
        Object.entries(this.filterState)
          .filter(([, value]) => !value)
          .map(([key]) => key)
          .join("")
      );
    },
    countActive(filters: { key: string }[]) {
      return filters.filter((f) => !this.filterState[f.key]).length;
    },
  },
});
</script>

<template>
  <div v-for="(filters, category) in categories" :key="category">
    <h3
      class="text-sm text-white flex items-center mb-1 cursor-pointer"
      v-if="category !== 'undefined'"
      @click="
        openCategory = openCategory === category ? null : (category as string)
      "
    >
      <klereo-icon
        name="chevron-down"
        class="transition-transform mr-1"
        :class="{ '-rotate-90': openCategory !== category }"
      />
      {{ $t("" + category) }}
      <span
        v-show="countActive(filters) > 0"
        class="text-xs text-gray-400 ml-2"
      >
        ({{ filters.length - countActive(filters) }}/{{ filters.length }})
      </span>
    </h3>
    <div
      class="transition-all overflow-hidden mb-2"
      :class="{
        'pl-5': category !== 'undefined',
        'max-h-0': openCategory !== category,
        'max-h-72': openCategory === category,
      }"
    >
      <div v-for="filter in filters" :key="filter.key">
        <label>
          <klereo-checkbox
            class="mr-2"
            v-model="filterState[filter.key]"
            @change="onStateChange()"
          />
          <span class="text-sm text-gray-400">{{
            filter.rawLabel || $t(filter.translationKey!)
          }}</span>
        </label>
      </div>
    </div>
  </div>
</template>
